import React from 'react';
import { Link } from 'react-router-dom';
import { Shield } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-border bg-muted/30" data-testid="footer">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1">
            <div className="flex items-center space-x-2 mb-4">
              <Shield className="h-6 w-6 text-primary" />
              <span className="font-heading text-xl font-bold">ScanMyAd</span>
            </div>
            <p className="text-sm text-muted-foreground">
              Multi-Jurisdiction Advertising Compliance Intelligence
            </p>
            <p className="text-xs text-muted-foreground mt-2">
              Reduce regulatory risk before your ads go live.
            </p>
          </div>

          <div>
            <h3 className="font-heading font-semibold mb-4">Product</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/pricing" className="hover:text-foreground transition-colors">Pricing</Link></li>
              <li><Link to="/about" className="hover:text-foreground transition-colors">About Us</Link></li>
              <li><Link to="/scanner" className="hover:text-foreground transition-colors">Scan Ad</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold mb-4">Legal</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/terms" className="hover:text-foreground transition-colors">Terms & Conditions</Link></li>
              <li><Link to="/privacy" className="hover:text-foreground transition-colors">Privacy Policy</Link></li>
              <li><Link to="/ai-transparency" className="hover:text-foreground transition-colors">AI Transparency</Link></li>
              <li><Link to="/acceptable-use" className="hover:text-foreground transition-colors">Acceptable Use</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading font-semibold mb-4">Contact</h3>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li>Email: support@scanmyad.com</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-border mt-8 pt-8 text-center">
          <p className="text-sm text-muted-foreground">© 2026 ScanMyAd. All rights reserved.</p>
          <p className="text-xs text-muted-foreground mt-2">Multi-Jurisdiction Advertising Compliance Intelligence</p>
          <p className="text-xs text-muted-foreground">Reduce regulatory risk before your ads go live.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
